module.exports = __webpack_public_path__ + "img/斯泰必鲁斯.png";